// extracted by mini-css-extract-plugin
export default {"warningRow":"CatalogStatusRow_warningRow__OPKQY","failedRow":"CatalogStatusRow_failedRow__Dpe+Z","tableCell":"CatalogStatusRow_tableCell__ZPjbA"};